export default __webpack_public_path__ + "static/media/Shirt11.3fbf666a.jpeg";